export default {
  path: 'usr-company/:idElement',
  name: 'MyUsrCompany',
  component: () => import('@/views/private/MyUsrCompany.vue'),
  props: true,
  children: [
    {
      path: 'communications-preference',
      name: 'CommunicationsPreference',
      component: () => import('@/components/my-usr-company/CommunicationsPreference.vue'),
    },
  ],
};
